// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__bmYXS","spin":"Loader_spin__TXlQJ"};